import { agLongestValue } from './ag-longest-value';
import { measureText } from './measure-text';

const clamp = (value: number, min: number, max: number) => {
  return Math.min(Math.max(value, min), max);
};

export const agWidthOfAColumn = <T>(ctx: {
  field: string;
  gridData: T[];
  headerName: string;
  maxWidth?: number;
  minWidth?: number;
  offset?: number;
}) => {
  const { field, gridData, headerName, maxWidth = 200, minWidth = 70, offset = 50 } = ctx;
  const cellWidth = measureText(agLongestValue(gridData, field as keyof T));
  const headerWidth = measureText(headerName);

  return clamp(Math.max(cellWidth, headerWidth) + offset, minWidth, maxWidth);
};
